import React from 'react';
import { Layout, LegacyCard, SkeletonPage, TextContainer, SkeletonBodyText, SkeletonDisplayText } from '@shopify/polaris';

export function SkeletonPageCustom() {
    return (
        <SkeletonPage>
            <Layout>
                <Layout.Section>
                    <LegacyCard sectioned>
                        <TextContainer>
                            <SkeletonDisplayText size="small" />
                            <SkeletonBodyText lines={9} />
                        </TextContainer>
                    </LegacyCard>
                </Layout.Section>
            </Layout>
        </SkeletonPage>
    );
}